import * as React from 'react';
import { SVG } from '../../../Utils/SVG';
import scrollToTop from '../../../../utils/scrollToTop';
const backToTopIconURL = require('../../../../icons/backtotop.svg');
import './style.css';

export interface BackToTopProps {
  /* empty */
}

export interface BackToTopState {
  /* empty */
}

export class BackToTop extends React.Component<BackToTopProps, BackToTopState> {
  render() {
    return (
      <div className="back-to-top">
        <a href="#app" className="back-to-top-link" onClick={this.scrollToTop}>
          <SVG className="back-to-top-icon" src={backToTopIconURL} />
          <span className="back-to-top-link-text">Back To Top</span>
        </a>
      </div>
    );
  }

  private scrollToTop = (event: React.MouseEvent<HTMLElement>) => {
    // Prevent it actually navigating to the anchor (which skips our animation)
    event.preventDefault();

    scrollToTop();
  };
}

export default BackToTop;



// WEBPACK FOOTER //
// ./src/app/components/App/Footer/BackToTop/index.tsx